import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';

export const BBMenu = ({
  sx,
  options,
  icon,
  anchor,
  setAnchor,
  menuProps,
  trigger,
  onClick,
}) => {
  const renderOptions = useMemo(() => {
    return options?.map(
      ({ label, isHidden, onClick: optionOnClick }) =>
        !isHidden && (
          <MenuItem
            key={label}
            sx={{ color: '#181d1f' }}
            onClick={() => {
              setAnchor(null);
              optionOnClick();
            }}
          >
            {label}
          </MenuItem>
        )
    );
  }, [options]);

  return (
    <Box sx={{ ...sx }}>
      {trigger ? (
        <>{trigger}</>
      ) : (
        <IconButton
          aria-controls="menu"
          aria-haspopup="true"
          size="large"
          sx={{ padding: '8px' }}
          onClick={(event) => {
            setAnchor(anchor ? null : event.currentTarget);
            onClick?.();
          }}
        >
          {icon ? <>{icon}</> : <MenuIcon fontSize="large" sx={{ color: '#181d1f' }} />}
        </IconButton>
      )}

      <Menu
        keepMounted
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        {...menuProps}
      >
        {renderOptions}
      </Menu>
    </Box>
  );
};

BBMenu.propTypes = {
  sx: PropTypes.any,
  options: PropTypes.any,
  icon: PropTypes.any,
  anchor: PropTypes.any,
  setAnchor: PropTypes.func,
  menuProps: PropTypes.any,
  trigger: PropTypes.any,
  onClick: PropTypes.func,
};
